import { render, staticRenderFns } from "./AssignMembersTransfer.vue?vue&type=template&id=835de0a6"
import script from "./AssignMembersTransfer.vue?vue&type=script&lang=js"
export * from "./AssignMembersTransfer.vue?vue&type=script&lang=js"
import style0 from "./AssignMembersTransfer.vue?vue&type=style&index=0&id=835de0a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports